import React, { useContext } from 'react';
import { ScopeContext } from '../Context/ScopeContext';
import { Row, Col } from 'react-bootstrap';
import MarketsColumn from './MarketsColumn';
import { useQuery, gql } from '@apollo/client';

const MarketsScope = () => {

    const { 
        selectedMarkets,
        setSelectedMarkets,
    } = useContext(ScopeContext);

    // Handle markets selection
    const handleSelectMarkets = (market) => {
        if(selectedMarkets.some(item => item.ref === market.ref)){
            const filteredMarkets = selectedMarkets.filter(item => item.ref !== market.ref)
            setSelectedMarkets(filteredMarkets)
        }else{
            setSelectedMarkets([
                ...selectedMarkets,
                market
            ])
        }
    };

    function getMarkets() {
	const uniqueMarkets = ['USD', 'CAD', 'MYR', 'AUD', 'GBP', 'SGD', 'EUR', 'EUR_Spain', 'HKD', 'JPY', 'CNY', 'MOP', 'TWD'];
        return uniqueMarkets;
    }

    return (
        <Row style={{ marginTop: '40px' }}>
            
            <Col md={4}> 
            <MarketsColumn 
                markets={getMarkets()} 
                onSelectMarket={handleSelectMarkets} 
                selectedMarkets={selectedMarkets}
                setSelectedMarkets={setSelectedMarkets}
            />
            </Col>

            <Col md={4}>
                <h5>Selected Markets</h5>
                <div className='selectedList'>
                {
                    selectedMarkets.length ? selectedMarkets.map(market => (
                        <div className='selectedProduct' key={market.name}>
                            {market.name}
                        </div>
                    )) : <>No Market selected</>
                }
                </div>
            </Col>
        </Row>
    );
};

export default MarketsScope;
